import React from "react";

interface SaveOrNotModalProps {
  onSaveClick: () => void;
  onDiscardClick: () => void;
  textMsg?: string;
  saveButtonText?: string;
  cancelButtonText?: string;
  isOpen: boolean;
  singleButton?: boolean;
}

const SaveOrNotModal: React.FC<SaveOrNotModalProps> = ({
  onSaveClick,
  onDiscardClick,
  saveButtonText = "Save Changes",
  cancelButtonText = "Discard Changes",
  textMsg = "You have unsaved changes. Please save or discard them before continuing.",
  isOpen,
  singleButton = true,
}) => {
  return (
    <div
      style={{
        position: "fixed",
        inset: "0",
        backgroundColor: "rgba(0, 0, 0, 0.3)",
        display: isOpen ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          width: "100%",
          maxWidth: "500px",
          borderRadius: "16px",
          padding: "24px",
          boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
        }}
      >
        <p
          style={{
            fontSize: "18px",
            fontWeight: "600",
            textAlign: "center",
            marginBottom: "24px",
          }}
        >
          {textMsg}
        </p>
        <div style={{ display: "flex", gap: "16px" }}>
          {singleButton == true && (
            <button
              onClick={onDiscardClick}
              style={{
                flex: 1,
                padding: "12px 16px",
                backgroundColor: "#e5e7eb",
                color: "#1f2937",
                fontWeight: "600",
                borderRadius: "50px",
                border: "none",
                cursor: "pointer",
              }}
            >
              {cancelButtonText}
            </button>
          )}
          <button
            onClick={onSaveClick}
            style={{
              flex: 1,
              padding: "12px 16px",
              backgroundColor: "#FFE500",
              color: "black",
              fontWeight: "600",
              borderRadius: "50px",
              border: "none",
              cursor: "pointer",
            }}
          >
            {saveButtonText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SaveOrNotModal;
